import { render, staticRenderFns } from "./event_categories.vue?vue&type=template&id=58a7fae2&"
import script from "./event_categories.vue?vue&type=script&lang=js&"
export * from "./event_categories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports